<div class="table" [style.--padding-y]="paddingY()" [style.--padding-x]="paddingX()">
    @if (isBrowser() && !showSkeleton()) {
        <div class="table__ntv-wrapper">
            <ntv-table
                #ntvTable
                [columns]="columns()"
                [data]="data()"
                [totalDataLength]="totalDataLength()"
                [hasCheckBox]="hasCheckBox"
                [hasIndex]="true"
                [tableHeight]="tableHeight()"
                [showColumnSettings]="showColumnSettings()"
                [filterEnabled]="filterEnabled()"
                lockIdentifierField="id"
                [showItemCount]="false"
                (selectedRowsChange)="onSelectionChange($event)"
                (showMoreRequested)="onShowMoreRequest()"
                (tableStateChange)="tableStateChange.emit($event)"
                [tableTitle]="tableTitle()">
                <ng-template #header let-column>
                    <span>{{ column.header }}</span>
                </ng-template>
                <ng-template
                    #body
                    let-rowData
                    let-columns="columns"
                    let-hasIndex="hasIndex"
                    let-rowIndex="rowIndex"
                    let-isLocked="isLocked"
                    let-onLockRow="onLockRow"
                    let-hasCheckBox="hasCheckBox"
                    let-onUnlockRow="onUnlockRow"
                    let-isRowSelected="isRowSelected"
                    let-onToggleRowSelection="onToggleRowSelection">
                    <tr [class.locked-row]="isLocked">
                        @if (hasCheckBox) {
                            <td class="checkbox-column-body">
                                <input
                                    type="checkbox"
                                    class="checkbox-input row-checkbox"
                                    [checked]="isRowSelected(rowData)"
                                    (change)="onToggleRowSelection(rowData)"
                                    [title]="
                                        isRowSelected(rowData) ? 'Deselect row' : 'Select row'
                                    " />
                            </td>
                        }
                        @if (hasIndex) {
                            <td class="index-column">{{ rowIndex }}</td>
                        }
                        @for (col of columns; track col.field) {
                            <td class="group">
                                @if (isTextTruncated(rowData, col)) {
                                    <span class="table__cell-tooltip">
                                        {{ getTooltipText(rowData, col) }}
                                    </span>
                                }
                                <div class="truncate">
                                    @if (getCustomTemplate(col.field)) {
                                        <ng-container
                                            [ngTemplateOutlet]="getCustomTemplate(col.field)!"
                                            [ngTemplateOutletContext]="{
                                                $implicit: rowData[col.field],
                                                row: rowData,
                                            }">
                                        </ng-container>
                                    } @else {
                                        @switch (getColumnType(col)) {
                                            @case ('status') {
                                                @if (hasValue(rowData[col.field])) {
                                                    <div
                                                        class="table__status"
                                                        [class.table__clickable-cell]="
                                                            getColProp(col, 'hasRedirect')
                                                        "
                                                        (click)="
                                                            getColProp(col, 'hasRedirect') &&
                                                                onCellClick(
                                                                    col.field,
                                                                    rowData[col.field],
                                                                    rowData
                                                                )
                                                        ">
                                                        <span
                                                            class="status-dot"
                                                            [style.background-color]="
                                                                getColProp(col, 'colorMap')?.[
                                                                    rowData[col.field]
                                                                ] ||
                                                                getColProp(col, 'color') ||
                                                                (rowData[col.field] === 'ON'
                                                                    ? '#8DCB2C'
                                                                    : '#94A3B8')
                                                            "></span>
                                                        {{ truncateText(rowData[col.field]) }}
                                                    </div>
                                                } @else {
                                                    --
                                                }
                                            }
                                            @case ('image') {
                                                <div
                                                    class="table__image"
                                                    [class.table__clickable-cell]="
                                                        getColProp(col, 'hasRedirect')
                                                    "
                                                    (click)="
                                                        getColProp(col, 'hasRedirect') &&
                                                            onCellClick(
                                                                col.field,
                                                                rowData[col.field],
                                                                rowData
                                                            )
                                                    ">
                                                    <img
                                                        [src]="rowData[col.field]"
                                                        alt="Screenshot" />
                                                </div>
                                            }
                                            @case ('copy') {
                                                @if (!hasValue(rowData[col.field])) {
                                                    --
                                                } @else {
                                                    <div class="table__copy">
                                                        @if (getColProp(col, 'hasRedirect')) {
                                                            <span
                                                                class="text-truncate table__clickable-cell"
                                                                (click)="
                                                                    onCellClick(
                                                                        col.field,
                                                                        rowData[col.field],
                                                                        rowData
                                                                    )
                                                                ">
                                                                @if (isArray(rowData[col.field])) {
                                                                    <div class="array-cell__list">
                                                                        @for (
                                                                            item of rowData[
                                                                                col.field
                                                                            ];
                                                                            track $index
                                                                        ) {
                                                                            <span>
                                                                                @if (
                                                                                    item.label &&
                                                                                    item.value
                                                                                ) {
                                                                                    <span
                                                                                        class="array-cell__item"
                                                                                        >{{
                                                                                            item.label
                                                                                        }}:</span
                                                                                    >
                                                                                    <span>{{
                                                                                        truncateText(
                                                                                            item.value
                                                                                        )
                                                                                    }}</span>
                                                                                } @else {
                                                                                    {{
                                                                                        truncateText(
                                                                                            item
                                                                                        )
                                                                                    }}
                                                                                }
                                                                                @if (
                                                                                    !$last &&
                                                                                    !item.label
                                                                                ) {
                                                                                    ,
                                                                                }
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                } @else if (
                                                                    isObject(rowData[col.field])
                                                                ) {
                                                                    {{
                                                                        truncateText(
                                                                            rowData[col.field]
                                                                                ?.label ||
                                                                                rowData[col.field]
                                                                                    ?.name ||
                                                                                rowData[col.field]
                                                                                    ?.id ||
                                                                                '---'
                                                                        )
                                                                    }}
                                                                } @else {
                                                                    {{
                                                                        truncateText(
                                                                            rowData[col.field] ||
                                                                                '---'
                                                                        )
                                                                    }}
                                                                }
                                                            </span>
                                                        } @else {
                                                            <span class="text-truncate">
                                                                @if (isArray(rowData[col.field])) {
                                                                    <div class="array-cell__list">
                                                                        @for (
                                                                            item of rowData[
                                                                                col.field
                                                                            ];
                                                                            track $index
                                                                        ) {
                                                                            <span>
                                                                                @if (
                                                                                    item.label &&
                                                                                    item.value
                                                                                ) {
                                                                                    <span
                                                                                        class="array-cell__item"
                                                                                        >{{
                                                                                            item.label
                                                                                        }}:</span
                                                                                    >
                                                                                    <span>{{
                                                                                        truncateText(
                                                                                            item.value
                                                                                        )
                                                                                    }}</span>
                                                                                } @else {
                                                                                    {{
                                                                                        truncateText(
                                                                                            item
                                                                                        )
                                                                                    }}
                                                                                }
                                                                                @if (
                                                                                    !$last &&
                                                                                    !item.label
                                                                                ) {
                                                                                    ,
                                                                                }
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                } @else {
                                                                    {{
                                                                        truncateText(
                                                                            rowData[col.field]
                                                                        )
                                                                    }}
                                                                }
                                                            </span>
                                                        }
                                                        <button
                                                            class="icon-btn"
                                                            [appCopy]="rowData[col.field]">
                                                            <svg width="12" height="12">
                                                                <use
                                                                    [attr.href]="
                                                                        spritePath +
                                                                        '#' +
                                                                        icons['copy']
                                                                    "></use>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                }
                                            }
                                            @case ('status-copy') {
                                                @if (!hasValue(rowData[col.field])) {
                                                    --
                                                } @else {
                                                    <div class="table__status-copy">
                                                        <span
                                                            class="status-dot"
                                                            [style.background-color]="
                                                                (rowData.statusColor || null) ??
                                                                (getColProp(col, 'color') ||
                                                                    (rowData[
                                                                        col.field + 'Status'
                                                                    ] === 'ON' ||
                                                                    rowData[col.field]?.status ===
                                                                        'ON'
                                                                        ? '#8DCB2C'
                                                                        : '#94A3B8'))
                                                            "></span>
                                                        @if (getColProp(col, 'hasRedirect')) {
                                                            <span
                                                                class="text-truncate table__clickable-cell"
                                                                (click)="
                                                                    onCellClick(
                                                                        col.field,
                                                                        rowData[col.field],
                                                                        rowData
                                                                    )
                                                                ">
                                                                @if (isArray(rowData[col.field])) {
                                                                    <div class="array-cell__list">
                                                                        @for (
                                                                            item of rowData[
                                                                                col.field
                                                                            ];
                                                                            track $index
                                                                        ) {
                                                                            <span>
                                                                                @if (
                                                                                    item.label &&
                                                                                    item.value
                                                                                ) {
                                                                                    <span
                                                                                        class="array-cell__item"
                                                                                        >{{
                                                                                            item.label
                                                                                        }}:</span
                                                                                    >
                                                                                    <span>{{
                                                                                        truncateText(
                                                                                            item.value,
                                                                                            getColProp(
                                                                                                col,
                                                                                                'truncateLimit'
                                                                                            )
                                                                                        )
                                                                                    }}</span>
                                                                                } @else {
                                                                                    {{
                                                                                        truncateText(
                                                                                            item,
                                                                                            getColProp(
                                                                                                col,
                                                                                                'truncateLimit'
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                }
                                                                                @if (
                                                                                    !$last &&
                                                                                    !item.label
                                                                                ) {
                                                                                    ,
                                                                                }
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                } @else if (
                                                                    isObject(rowData[col.field])
                                                                ) {
                                                                    {{
                                                                        truncateText(
                                                                            rowData[col.field]
                                                                                ?.label ||
                                                                                rowData[col.field]
                                                                                    ?.name ||
                                                                                rowData[col.field]
                                                                                    ?.id ||
                                                                                '---',
                                                                            getColProp(
                                                                                col,
                                                                                'truncateLimit'
                                                                            )
                                                                        )
                                                                    }}
                                                                } @else {
                                                                    {{
                                                                        truncateText(
                                                                            rowData[col.field] ||
                                                                                '---',
                                                                            getColProp(
                                                                                col,
                                                                                'truncateLimit'
                                                                            )
                                                                        )
                                                                    }}
                                                                }
                                                            </span>
                                                        } @else {
                                                            <span class="text-truncate">
                                                                @if (isArray(rowData[col.field])) {
                                                                    <div class="array-cell__list">
                                                                        @for (
                                                                            item of rowData[
                                                                                col.field
                                                                            ];
                                                                            track $index
                                                                        ) {
                                                                            <span>
                                                                                @if (
                                                                                    item.label &&
                                                                                    item.value
                                                                                ) {
                                                                                    <span
                                                                                        class="array-cell__item"
                                                                                        >{{
                                                                                            item.label
                                                                                        }}:</span
                                                                                    >
                                                                                    <span>{{
                                                                                        truncateText(
                                                                                            item.value
                                                                                        )
                                                                                    }}</span>
                                                                                } @else {
                                                                                    {{
                                                                                        truncateText(
                                                                                            item
                                                                                        )
                                                                                    }}
                                                                                }
                                                                                @if (
                                                                                    !$last &&
                                                                                    !item.label
                                                                                ) {
                                                                                    ,
                                                                                }
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                } @else {
                                                                    {{
                                                                        truncateText(
                                                                            rowData[col.field]
                                                                        )
                                                                    }}
                                                                }
                                                            </span>
                                                        }
                                                        <button
                                                            class="icon-btn"
                                                            [appCopy]="rowData[col.field]">
                                                            <svg
                                                                width="12"
                                                                height="12"
                                                                class="text-[#8DCB2C]">
                                                                <use
                                                                    [attr.href]="
                                                                        spritePath +
                                                                        '#' +
                                                                        icons['copy']
                                                                    "></use>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                }
                                            }
                                            @case ('actions') {
                                                <div class="table__actions">
                                                    @for (
                                                        action of resolveTableActionsCount(
                                                            getColProp(col, 'actions')
                                                        );
                                                        track action.icon + $index
                                                    ) {
                                                        <button
                                                            class="icon-btn"
                                                            [attr.title]="action.name"
                                                            [attr.aria-label]="action.name"
                                                            [class.text-red-500]="
                                                                !action.color &&
                                                                action.icon === 'delete'
                                                            "
                                                            [class.text-accent-main]="
                                                                !action.color &&
                                                                (action.icon === 'export' ||
                                                                    action.icon === 'screens')
                                                            "
                                                            (click)="
                                                                $event.stopPropagation();
                                                                onActionClick(action.name, rowData)
                                                            ">
                                                            <svg
                                                                [attr.width]="action.size || 14"
                                                                [attr.height]="action.size || 14"
                                                                [style.color]="
                                                                    action.color || null
                                                                ">
                                                                <use
                                                                    [attr.href]="
                                                                        spritePath +
                                                                        '#' +
                                                                        (icons[action.icon] ||
                                                                            action.icon)
                                                                    "></use>
                                                            </svg>
                                                        </button>
                                                    }
                                                    @if (getColProp(col, 'actions').length > 3) {
                                                        <app-table-actions
                                                            [actions]="
                                                                getColProp(col, 'actions').slice(2)
                                                            "
                                                            [rowData]="rowData" />
                                                    }
                                                </div>
                                            }
                                            @default {
                                                @if (getColProp(col, 'hasRedirect')) {
                                                    <span
                                                        class="table__clickable-cell"
                                                        (click)="
                                                            onCellClick(
                                                                col.field,
                                                                rowData[col.field],
                                                                rowData
                                                            )
                                                        ">
                                                        @if (isArray(rowData[col.field])) {
                                                            @if (rowData[col.field].length === 0) {
                                                                --
                                                            } @else {
                                                                <div class="array-cell__list">
                                                                    @for (
                                                                        item of rowData[col.field];
                                                                        track $index
                                                                    ) {
                                                                        <span>
                                                                            @if (
                                                                                item.label &&
                                                                                item.value
                                                                            ) {
                                                                                <span
                                                                                    class="array-cell__item"
                                                                                    >{{
                                                                                        item.label
                                                                                    }}:</span
                                                                                >
                                                                                <span>{{
                                                                                    truncateText(
                                                                                        item.value,
                                                                                        getColProp(
                                                                                            col,
                                                                                            'truncateLimit'
                                                                                        )
                                                                                    )
                                                                                }}</span>
                                                                            } @else {
                                                                                {{
                                                                                    truncateText(
                                                                                        item,
                                                                                        getColProp(
                                                                                            col,
                                                                                            'truncateLimit'
                                                                                        )
                                                                                    )
                                                                                }}
                                                                            }
                                                                            @if (
                                                                                !$last &&
                                                                                !item.label
                                                                            ) {
                                                                                ,
                                                                            }
                                                                        </span>
                                                                    }
                                                                </div>
                                                            }
                                                        } @else if (isObject(rowData[col.field])) {
                                                            {{
                                                                truncateText(
                                                                    rowData[col.field]?.label ||
                                                                        rowData[col.field]?.name ||
                                                                        rowData[col.field]?.id ||
                                                                        '--',
                                                                    getColProp(col, 'truncateLimit')
                                                                )
                                                            }}
                                                        } @else {
                                                            {{
                                                                truncateText(
                                                                    rowData[col.field],
                                                                    getColProp(col, 'truncateLimit')
                                                                )
                                                            }}
                                                        }
                                                    </span>
                                                } @else {
                                                    @if (isArray(rowData[col.field])) {
                                                        @if (rowData[col.field].length === 0) {
                                                            --
                                                        } @else {
                                                            <div class="array-cell__list">
                                                                @for (
                                                                    item of rowData[col.field];
                                                                    track $index
                                                                ) {
                                                                    <span>
                                                                        @if (
                                                                            item.label && item.value
                                                                        ) {
                                                                            <span
                                                                                class="array-cell__item"
                                                                                >{{
                                                                                    item.label
                                                                                }}:</span
                                                                            >
                                                                            <span>{{
                                                                                truncateText(
                                                                                    item.value,
                                                                                    getColProp(
                                                                                        col,
                                                                                        'truncateLimit'
                                                                                    )
                                                                                )
                                                                            }}</span>
                                                                        } @else {
                                                                            {{
                                                                                truncateText(
                                                                                    item,
                                                                                    getColProp(
                                                                                        col,
                                                                                        'truncateLimit'
                                                                                    )
                                                                                )
                                                                            }}
                                                                        }
                                                                        @if (
                                                                            !$last && !item.label
                                                                        ) {
                                                                            ,
                                                                        }
                                                                    </span>
                                                                }
                                                            </div>
                                                        }
                                                    } @else if (isObject(rowData[col.field])) {
                                                        {{
                                                            truncateText(
                                                                rowData[col.field]?.label ||
                                                                    rowData[col.field]?.name ||
                                                                    rowData[col.field]?.id ||
                                                                    '--',
                                                                getColProp(col, 'truncateLimit')
                                                            )
                                                        }}
                                                    } @else {
                                                        {{
                                                            truncateText(
                                                                rowData[col.field],
                                                                getColProp(col, 'truncateLimit')
                                                            )
                                                        }}
                                                    }
                                                }
                                            }
                                        }
                                    }
                                </div>
                            </td>
                        }
                    </tr>
                </ng-template>
            </ntv-table>

            @if (showItemCount()) {
                <div class="table__pagination">
                    <p class="table__pagination-text">
                        Showing <strong>{{ data().length }}</strong> out of
                        <strong>{{ totalDataLength() }}</strong> items
                    </p>
                    @if (hasMoreItems()) {
                        <button
                            type="button"
                            class="table__pagination-toggle"
                            (click)="onShowMoreClick()">
                            Show More
                        </button>
                    } @else if (canShowLess()) {
                        <button
                            type="button"
                            class="table__pagination-toggle"
                            (click)="onShowLessClick()">
                            Show Less
                        </button>
                    }
                </div>
            }

            @if (resolvedLoadingOverlay()) {
                <div class="table__loading-overlay">
                    <div class="table__progress-bar"></div>
                    <div class="table__loading-backdrop">
                        <div class="table__loading-spinner"></div>
                        <span class="table__loading-text">Loading...</span>
                    </div>
                </div>
            }
        </div>
    } @else {
        <!-- Ghost Table for SSR/Initial Load/Fetching API -->
        <div class="bg-white rounded-lg border border-slate-100 overflow-hidden w-full">
            <table class="w-full border-collapse table-auto">
                <!-- Ghost Header -->
                <thead class="bg-slate-50/50">
                    <tr class="border-b border-slate-100">
                        @if (hasCheckBox) {
                            <th
                                class="w-[50px] text-center"
                                [style.padding]="paddingY() + ' ' + paddingX()">
                                <ntv-skeleton width="18px" height="18px"></ntv-skeleton>
                            </th>
                        }
                        <th
                            class="w-[50px] text-center"
                            [style.padding]="paddingY() + ' ' + paddingX()">
                            <ntv-skeleton width="20px" height="18px"></ntv-skeleton>
                        </th>
                        @for (col of columns(); track col.field) {
                            <th
                                class="text-left"
                                [style.padding]="paddingY() + ' ' + paddingX()"
                                [style.width]="col.width || '150px'">
                                <ntv-skeleton variant="title" width="60%"></ntv-skeleton>
                            </th>
                        }
                    </tr>
                </thead>
                <!-- Ghost Rows -->
                <tbody>
                    @for (rowIndex of skeletonRowIndices(); track rowIndex) {
                        <tr class="border-b border-slate-50">
                            @if (hasCheckBox) {
                                <td
                                    class="text-center"
                                    [style.padding]="paddingY() + ' ' + paddingX()">
                                    <ntv-skeleton
                                        variant="thumbnail"
                                        width="18px"
                                        height="18px"
                                        borderRadius="4px"></ntv-skeleton>
                                </td>
                            }
                            <td class="text-center" [style.padding]="paddingY() + ' ' + paddingX()">
                                <ntv-skeleton
                                    variant="text"
                                    width="20px"
                                    height="18px"></ntv-skeleton>
                            </td>
                            @for (col of columns(); track col.field) {
                                <td
                                    [style.padding]="paddingY() + ' ' + paddingX()"
                                    [style.width]="col.width || '150px'">
                                    @if (getColumnType(col) === 'image') {
                                        <ntv-skeleton
                                            variant="thumbnail"
                                            width="80px"
                                            height="40px"
                                            borderRadius="4px"></ntv-skeleton>
                                    } @else {
                                        <ntv-skeleton
                                            variant="text"
                                            width="80%"
                                            height="18px"></ntv-skeleton>
                                    }
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</div>
